/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import ReactHTMLParser from 'react-html-parser';
import { useSelector  } from 'react-redux';

import { array, func, bool } from 'prop-types';
import determineProductUrl from '../../../../../helpers/determineProductUrl';
import ProductImage from '../../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/ProductImage';
import PriceRange from '../../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/PriceRange';
import noop from '../../../../../helpers/noop';
import { getPriceRangeLayout, getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const useStyles = makeStyles((theme) => ({
    productContainer: {
        display: 'flex',
        gap: '16px',
        overflowX: 'auto',
        scrollSnapType: 'x mandatory',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
    product: {
        flex: '0 0 34%', // Adjust width for 2.5 items in view
        position: 'relative',
        scrollSnapAlign: 'start',
        '& img': {
            width: '100%',
            position: 'static',
            [theme.breakpoints.down(600)]: {
                width: '8.438rem',
                height: '9.25rem',
            },
        },
        '&:last-child': {
            marginRight: '16px',
        },
    },
    priceContainer: {
        position: 'absolute',
        backgroundColor: 'white',
        bottom: '10px',
        left: '10px',
        padding: '4px 6px',
        borderRadius: 2,
        textTransform: 'capitalize',
        fontFamily: 'Lato',
        color: 'black',
        '& span': {
            fontWeight: '700',
            fontSize: '14px',
        },
    },
    resetPadding: {
        padding: 'unset',
        [theme.breakpoints.down(600)]: {
            width: '6.25rem',
            '& div': {
                width: '6.25rem',
            },
        },
    },
}));

const MobileCarousel = ({
    products, handleLinkOnClick, dynamicPriceInstance, productSkuPrices, dynamicPriceIsLoading,
}) => {
    const classes = useStyles();
    const priceRangeLayout = useSelector(getPriceRangeLayout);
    const isDynamicPriceEnabled = useSelector((state) => getFeatureFlag('is-dynamic-pricing-enabled')(state));
    const priceRangeLayoutFromCMS = priceRangeLayout && priceRangeLayout?.length > 0 ? priceRangeLayout : [{ viewport: 'Mobile', price_layout: 'from $xxx.xx' }, { viewport: 'Desktop', price_layout: 'from $xxx.xx' }];

    const {
        getRetailPrice, getSalePrice,
    } = dynamicPriceInstance;

    return (
        <div className={classes.productContainer} data-testid="mobile-carousel">
            {products?.map((product) => {
                const {
                    name, image, skuPriceRange, partNumber, seo,
                } = product;
                let updatedSkuPriceRange = {};
                if (productSkuPrices.length > 0) {
                    const dynamicPriceList = productSkuPrices?.find?.((item) => item?.id === partNumber)?.prices?.sort((firstPriceItem, secondPriceItem) => firstPriceItem.value - secondPriceItem.value) || [];
                    if (isDynamicPriceEnabled && dynamicPriceList.length > 0) {
                        updatedSkuPriceRange = {
                            retail: [{ value: getRetailPrice(dynamicPriceList) }],
                            sale: [{ value: getSalePrice(dynamicPriceList) }],
                        };
                    }
                }
                return (
                    <Link
                        data-testid={`${name}${'-'}${partNumber}`?.split(' ')?.join('-')?.toLowerCase()}
                        data-test="recommended-product"
                        title={`${ReactHTMLParser(name)}`}
                        tabIndex="0"
                        to={determineProductUrl(seo?.url)}
                        onClick={() => handleLinkOnClick(partNumber)}
                        className={classes.product}
                        key={name}
                    >
                        <ProductImage image={image} name={name} />
                        <div className={`${classes.priceContainer} ${isDynamicPriceEnabled && dynamicPriceIsLoading ? classes.resetPadding : ''}`}>
                            <PriceRange
                                skuPriceRange={isDynamicPriceEnabled ? updatedSkuPriceRange : skuPriceRange}
                                priceRangeLayout={priceRangeLayoutFromCMS}
                                displayPrice={isDynamicPriceEnabled ? !dynamicPriceIsLoading : true}
                            />
                        </div>
                    </Link>
                );
            })}
        </div>
    );
};

MobileCarousel.propTypes = {
    products: array,
    handleLinkOnClick: func,
    dynamicPriceInstance: func,
    productSkuPrices: array,
    dynamicPriceIsLoading: bool,
};

MobileCarousel.defaultProps = {
    products: [],
    handleLinkOnClick: noop,
    dynamicPriceInstance: noop,
    productSkuPrices: [],
    dynamicPriceIsLoading: false,
};

export default MobileCarousel;
